/**
 * Fallback de revisão no frontend quando meta.review não vier da API.
 */

import { formatAutomationDisplayValue, formatScheduleIntervalLabel } from "./automationLabelFormat";
import {
  formatScheduleRunWindowLabel,
  isScheduleConditionMetaKey,
} from "./scheduleRunWindow";

export function unwrapSuggestResponse(res) {
  const layer1 = res?.data ?? res;
  if (layer1?.suggestion) return layer1;
  if (layer1?.data?.suggestion) return layer1.data;
  return layer1;
}

export function isSuggestionComplete(suggestion) {
  if (!suggestion) return false;
  const cond = suggestion.condicoes || {};
  const hasSchedule = cond.schedule_interval != null;
  const filterKeys = Object.keys(cond).filter((k) => !isScheduleConditionMetaKey(k));
  const hasFilters = filterKeys.length > 0 || hasSchedule;
  const hasActions = Array.isArray(suggestion.acoes) && suggestion.acoes.length > 0;
  return hasFilters && hasActions;
}

export function normalizeReviewCondition(item) {
  if (!item) return { label: "", value: "" };
  let label = String(item.label || item.key || "").trim();
  let value = formatAutomationDisplayValue(item.valueLabel ?? item.value).trim();
  if (label && value.toLowerCase().startsWith(`${label.toLowerCase()}:`)) {
    value = value.slice(label.length + 1).trim();
  }
  return { label, value };
}

export function buildClientReviewFallback(suggestion, meta = {}) {
  const condicoes = [];
  const labels = suggestion?.condicoes_labels || {};
  const raw = suggestion?.condicoes || {};

  if (raw.schedule_interval) {
    condicoes.push({
      key: "schedule_interval",
      label: "Intervalo",
      valueLabel:
        formatAutomationDisplayValue(labels.schedule_interval) ||
        formatScheduleIntervalLabel(raw.schedule_interval),
    });
  }

  if (raw.schedule_run_window) {
    condicoes.push({
      key: "schedule_run_window",
      label: "Horário de execução",
      valueLabel:
        formatAutomationDisplayValue(labels.schedule_run_window) ||
        formatScheduleRunWindowLabel(raw.schedule_run_window),
    });
  }

  for (const [key, value] of Object.entries(raw)) {
    if (isScheduleConditionMetaKey(key)) continue;
    const full = formatAutomationDisplayValue(labels[key]) || formatAutomationDisplayValue(value);
    const split = full.includes(":") ? full.split(":") : [key, full];
    const label = split[0].trim();
    const valueLabel = (split.slice(1).join(":") || String(value)).trim();
    condicoes.push({ key, label, value, valueLabel });
  }

  const acoes = (suggestion?.acoes || []).map((a, idx) => ({
    id: a.id,
    nome: meta?.eventoNome ? `Ação #${a.id}` : `Ação #${a.id}`,
    ordem: idx + 1,
    parametros: Object.entries(a.values || {}).map(([k, v]) => ({
      key: k,
      label: k,
      valueLabel: formatAutomationDisplayValue(v),
      pending: false,
    })),
  }));

  return { condicoes, acoes };
}
